import { environment } from '../../environments/environment';

export async function unsubscribePushNotifications(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  const worker = await navigator.serviceWorker.ready;
  const sub = await worker.pushManager.getSubscription();
  if (sub == null) {
    return;
  }
  const unsubscribed = await sub.unsubscribe();
  if (!unsubscribed) {
    console.warn('failed to unsubscribe at logout');
  }
}

export async function subscribePushNotifications(): Promise<PushSubscription | null> {
  if (!('serviceWorker' in navigator)) {
    return null;
  }
  const notificationPermission = await Notification.requestPermission();
  if (notificationPermission !== 'granted') {
    return null;
  }
  const worker = await navigator.serviceWorker.ready;
  // An active subscription might belong to a different user, so cancel it.
  // (the subscribe method always returns an existing subscription if one exists,
  // so we could also handle this in the backend by allowing each endpoint to be bound
  // to only one user at a time)
  const oldSub = await worker.pushManager.getSubscription();
  if (oldSub != null) {
    const unsubscribed = await oldSub.unsubscribe();
    if (!unsubscribed) {
      console.warn('old subscription not unsubscribed');
    }
  }

  return await worker.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: environment.vapidPublicKey,
  });
}
